import { render, staticRenderFns } from "./order-trainlog.vue?vue&type=template&id=4aac87bf&scoped=true"
import script from "./order-trainlog.vue?vue&type=script&lang=js"
export * from "./order-trainlog.vue?vue&type=script&lang=js"
import style0 from "./order-trainlog.vue?vue&type=style&index=0&id=4aac87bf&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aac87bf",
  null
  
)

export default component.exports